/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetClassRoomResponse } from './GetClassRoomResponse';
import {
    GetClassRoomResponseFromJSON,
    GetClassRoomResponseFromJSONTyped,
    GetClassRoomResponseToJSON,
    GetClassRoomResponseToJSONTyped,
} from './GetClassRoomResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetClassRoomResponse
 */
export interface PaginatedResultOfGetClassRoomResponse {
    /**
     * 
     * @type {Array<GetClassRoomResponse>}
     * @memberof PaginatedResultOfGetClassRoomResponse
     */
    items?: Array<GetClassRoomResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetClassRoomResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetClassRoomResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetClassRoomResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetClassRoomResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetClassRoomResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetClassRoomResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetClassRoomResponse interface.
 */
export function instanceOfPaginatedResultOfGetClassRoomResponse(value: object): value is PaginatedResultOfGetClassRoomResponse {
    return true;
}

export function PaginatedResultOfGetClassRoomResponseFromJSON(json: any): PaginatedResultOfGetClassRoomResponse {
    return PaginatedResultOfGetClassRoomResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetClassRoomResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetClassRoomResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetClassRoomResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetClassRoomResponseToJSON(json: any): PaginatedResultOfGetClassRoomResponse {
    return PaginatedResultOfGetClassRoomResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetClassRoomResponseToJSONTyped(value?: PaginatedResultOfGetClassRoomResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetClassRoomResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

